import { AdminRole } from '~/features/admin/types/admin.type';

/**
 * 역할별 라벨 및 색상
 */
export const ADMIN_ROLE_LABELS: Record<AdminRole, { label: string; color: string }> = {
  [AdminRole.MASTER]: { label: '마스터', color: 'purple' },
  [AdminRole.SUPER_ADMIN]: { label: '슈퍼 관리자', color: 'magenta' },
  [AdminRole.ADMIN]: { label: '관리자', color: 'geekblue' },
  [AdminRole.SALES]: { label: '영업담당', color: 'blue' },
  [AdminRole.STORE_OWNER]: { label: '점주', color: 'cyan' },
  [AdminRole.MANAGER]: { label: '매니저', color: 'green' },
};

/** 본사 역할 (DB에서 직접 관리) */
export const HQ_ROLES = [AdminRole.MASTER, AdminRole.SUPER_ADMIN, AdminRole.ADMIN];

/** 매장 관련 역할 (storeId 필요) */
export const STORE_ROLES = [AdminRole.SALES, AdminRole.STORE_OWNER, AdminRole.MANAGER];

/** 운영자 역할 (시스템 설정) */
export const OPERATOR_ROLES: AdminRole[] = [
  AdminRole.MASTER,
  AdminRole.SUPER_ADMIN,
  AdminRole.ADMIN,
];

/** 점주/매니저 역할 (서비스 운영) */
export const STORE_MANAGER_ROLES: AdminRole[] = [AdminRole.STORE_OWNER, AdminRole.MANAGER];

/** 영업 역할 (서비스 운영) */
export const SALES_ROLES: AdminRole[] = [AdminRole.SALES];

/** 어드민 콘솔 접근 허용 역할 (라우트 가드) */
export const ADMIN_CONSOLE_ROLES: AdminRole[] = [
  AdminRole.MASTER,
  AdminRole.SUPER_ADMIN,
  AdminRole.ADMIN,
  AdminRole.SALES,
];

/** 점주 콘솔 접근 허용 역할 (라우트 가드) */
export const STORE_CONSOLE_ROLES: AdminRole[] = [AdminRole.STORE_OWNER, AdminRole.MANAGER];
